









import { Vue, Component, Watch } from 'vue-property-decorator';
import { getBaseinfo } from '@/api/api';
import { isMobile } from '@/common/ts/common';
import { Banner } from '@/components';

@Component({
  name: 'RouteViewHolder',
  components: {
    Banner,
  },
})
export default class RouteViewHolder extends Vue {
  voteName: string = '2019poject/2019new70years';
  bannerShow: boolean = true;
  banner: string = '';
  async created() {
    if (!isMobile()) {
      location.href = 'http://vote.cqcb.com/shangyou_activity/zhuangli_70/';
      return;
    }
    const res = await getBaseinfo(this.voteName);
    this.banner = res.data.banner;
  }
  @Watch('$route', {
    immediate: true,
  })
  onRouterChange(to: any, from: any) {
    if (to.name === 'Welcome') {
      this.bannerShow = false;
    } else {
      this.bannerShow = true;
    }
  }
}
